<template>
  <div class="commodity-list">
    <second-menu-link-content>
      <template v-slot:header>
        <span>商品列表</span>
      </template>
      <template v-slot:content>
        <div class="commodity-list-main" ref="main">
          <div
            class="btn"
            v-show="
              operationList.findIndex(
                (item) => item === operationsBtns.roleGoodsAdd
              ) !== -1
            "
          >
            <el-button class="btn-blue" @click="addcommodity()"
              >新增商品</el-button
            >
          </div>
          <div class="form">
            <el-form ref="form" :model="form" label-width="100px">
              <div class="flex">
                <el-form-item label="商品筛选：" prop="codeName">
                  <el-input
                    class="white w160"
                    v-model="form.codeName"
                    @keyup.enter.native="screen"
                    clearable
                    placeholder="请输入商品名称/商品编码"
                  ></el-input>
                </el-form-item>
                <el-form-item label="商品分类：" prop="classify">
                  <el-cascader
                    clearable
                    class="white w160"
                    v-model="form.classify"
                    :options="classify"
                    :props="defaultParams"
                    placeholder="选择分类"
                    filterable
                    :show-all-levels="false"
                  ></el-cascader>
                </el-form-item>
                <el-form-item label="商品状态：" prop="state">
                  <el-select v-model="form.state" clearable class="white w160">
                    <el-option
                      v-for="item in state"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="flex">
                <el-form-item label="创建日期：" prop="time">
                  <el-date-picker
                    class="w280"
                    v-model="form.time"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="商品品牌：" prop="brand">
                  <el-select
                    v-model="form.brand"
                    filterable
                    clearable
                    class="white w160"
                    placeholder="请选择品牌"
                  >
                    <el-option
                      v-for="item in brand"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                  <el-form-item label="商品从属：" prop="username">
                    <el-select
                      v-model="form.username"
                      clearable
                      filterable
                      class="white w160"
                    >
                      <el-option
                        v-for="(item, index) in userNameList"
                        :key="index"
                        :label="item.username"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
              </div>
              <div class="flex">
                <el-form-item label-width="30px">
                  <el-checkbox v-model="form.sellOut">即将售罄</el-checkbox>
                  <span class="inventory-text">（商品可售库存≤10件）</span>
                </el-form-item>
                <el-form-item label-width="224px">
                  <el-button class="btn-blue" @click="screen">筛选</el-button>
                  <el-button
                    class="btn-white"
                    v-show="
                      operationList.findIndex(
                        (item) => item === operationsBtns.roleGoodsExport
                      ) !== -1
                    "
                    @click="exportExcel"
                    >导出报表</el-button
                  >
                  <el-button
                    type="text"
                    class="btn-text"
                    @click="resetForm('form')"
                    >清空筛选条件</el-button
                  >
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="table" ref="table">
            <div class="table_list" ref="table_list">
              <el-table
                ref="multipleTable"
                :data="tableData"
                v-loading="loading"
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection" width="50"></el-table-column>
                <el-table-column prop="name" label="商品名称" min-width="240">
                  <template slot-scope="scope">
                    <el-image
                      class="img"
                      :src="scope.row.img"
                      fit="contain"
                      lazy
                      @click="toPreviewProduct(scope.row.id)"
                    ></el-image>
                    <p
                      class="name"
                      :title="scope.row.name"
                      v-html="scope.row.name"
                    ></p>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="zip"
                  label="商品编码"
                  min-width="140"
                ></el-table-column>
                <el-table-column
                  class="state"
                  prop="state"
                  label="商品状态"
                  min-width="85"
                >
                  <template slot-scope="scope">
                    <span
                      :class="scope.row.state === '上架' ? 'green' : 'orange'"
                    ></span>
                    <span>{{ scope.row.state }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="categoryName"
                  label="商品分类"
                  min-width="200"
                ></el-table-column>
                <el-table-column
                  prop="sales"
                  label="销量"
                  min-width="80"
                ></el-table-column>
                <el-table-column
                  prop="time"
                  label="创建日期"
                  min-width="90"
                >
                  <template slot-scope="scope">
                    <div>
                      <p>{{ scope.row.time }}</p>
                      <p class="operationLog" @click="operationLog(scope.row.id)">操作日志</p>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="commissionRate"
                  label="抽佣比例"
                  min-width="80"
                  v-if="maidFlag === 1 ? true : false"
                >
                  <template slot-scope="scope">
                    <p>
                      <span>{{ scope.row.commissionRate.toFixed(2) }}%</span>
                    </p>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="username"
                  label="商品从属"
                  min-width="140"
                >
                  <template slot-scope="scope">
                    <p>
                      <span
                        :class="{
                          active:
                            operationList.findIndex(
                              (item) =>
                                item === operationsBtns.roleGoodsSubordination
                            ) !== -1,
                        }"
                        @click="
                          operationList.findIndex(
                            (item) =>
                              item === operationsBtns.roleGoodsSubordination
                          ) !== -1
                            ? goodsSubordination(scope.row)
                            : ''
                        "
                        >{{ scope.row.username }}</span
                      >
                    </p>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  min-width="200"
                  v-if="
                    operationList.indexOf(operationsBtns.roleGoodsManage) !==
                      -1 ||
                    operationList.indexOf(operationsBtns.roleGoodsDelete) !== -1
                  "
                >
                  <template slot-scope="scope">
                    <div
                      class="up-down-update"
                      v-if="
                        operationList.indexOf(
                          operationsBtns.roleGoodsManage
                        ) !== -1
                      "
                    >
                      <el-button
                        @click.native.prevent="editRow(scope.row.id)"
                        class="btn-text"
                        type="text"
                        >编辑</el-button
                      >
                      <el-button
                        @click.native.prevent="downGoods(scope.row.id)"
                        type="text"
                        class="btn-text"
                        v-if="scope.row.status === 1"
                        >下架</el-button
                      >
                      <el-button
                        @click.native.prevent="upGoods(scope.row.id)"
                        type="text"
                        class="btn-text"
                        v-if="scope.row.status === 0 || scope.row.status === 3"
                        >上架</el-button
                      >
                      <el-button
                        @click.native.prevent="agreeGoods(scope.row.id)"
                        type="text"
                        class="btn-text"
                        v-if="
                        operationList.indexOf(
                          operationsBtns.roleGoodsReview
                        ) !== -1 && scope.row.status === 2"
                        >审核</el-button
                      >

                      <el-button
                        type="text"
                        class="btn-text"
                        v-clipboard:copy="'/product?id=' + scope.row.id"
                        v-clipboard:success="onCopy"
                        >复制</el-button
                      >
                    </div>
                    <el-button
                      @click.native.prevent="deleteRow(scope.row.id)"
                      type="text"
                      class="btn-text"
                      v-if="
                        operationList.indexOf(
                          operationsBtns.roleGoodsDelete
                        ) !== -1
                      "
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="table_pagination">
              <div class="batch-operation">
                <el-button
                  v-if="
                    operationList.indexOf(operationsBtns.roleGoodsManage) !==
                      -1 ||
                    operationList.indexOf(operationsBtns.roleGoodsDelete) !== -1
                  "
                  ref="btn"
                  id="btn-batch-operation"
                  class="btn-white"
                  >批量操作</el-button
                >
                <ul class="operation-list">
                  <li
                    v-if="
                      operationList.findIndex(
                        (item) => item === operationsBtns.roleGoodsSubordination
                      ) !== -1
                    "
                    @click="openDialog(8)"
                  >
                    设置商品从属
                  </li>
                  <template
                    v-if="
                      operationList.indexOf(operationsBtns.roleGoodsDelete) !==
                      -1
                    "
                  >
                    <li @click="openDialog(1)">删除选中商品</li>
                  </template>
                  <template
                    v-if="
                      operationList.indexOf(operationsBtns.roleGoodsManage) !==
                      -1
                    "
                  >
                    <li @click="openDialog(2)">设置商品品牌</li>
                    <li @click="openDialog(3)">设置商品标签</li>
                    <li @click="openDialog(4)">设置商品分类</li>
                    <li @click="openDialog(7)">设置商品参数</li>
                    <li @click="openDialog(5)">设置上架下架</li>
                    <li @click="openDialog(6)">设置运费模板</li>
                  </template>
                </ul>
              </div>
              <pagination-tpl
                @queryChange="updatePage"
                :pageSize="pageSize"
                :currentPage="page"
                :total="total"
              ></pagination-tpl>
            </div>
          </div>
          <el-dialog
            :title="operationType === 8 ? '设置商品从属' : '批量操作'"
            :visible.sync="dialogVisible"
            :width="operationType === 7 ? '700px' : '400px'"
            :top="operationType === 7 ? '10vh' : '25vh'"
            :class="operationType == 8 ? 'goodsSubordinationList' : ''"
          >
            <!-- 黑色的线条 -->
            <div class="border" v-if="operationType !== 8"></div>
            <el-form
              :model="operationForm"
              ref="operationForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item v-if="operationType === 1">
                <span>是否确定删除所选的商品</span>
              </el-form-item>
              <el-form-item label="商品品牌：" v-if="operationType === 2">
                <el-select
                  v-model="operationForm.brand"
                  class="gray"
                  clearable
                  filterable
                  placeholder="请选择品牌"
                >
                  <el-option
                    v-for="item in brand"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="商品标签：" v-if="operationType === 3">
                <el-select
                  v-model="operationForm.label"
                  class="gray"
                  placeholder="请选择标签"
                >
                  <el-option
                    v-for="item in label"
                    :key="item.id"
                    :label="item.labelName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="商品分类：" v-if="operationType === 4">
                <el-cascader
                  clearable
                  class="white w160"
                  v-model="operationForm.classify"
                  :options="classify"
                  :props="defaultParams"
                  placeholder="选择分类"
                  filterable
                  :show-all-levels="false"
                ></el-cascader>
              </el-form-item>
              <el-form-item label="商品状态：" v-if="operationType === 5">
                <el-radio-group v-model="operationForm.status">
                  <el-radio :label="1">上架</el-radio>
                  <el-radio :label="0">下架</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="运费模板：" v-if="operationType === 6">
                <el-select
                  v-model="operationForm.freightId"
                  class="gray"
                  placeholder="请选择标签"
                >
                  <el-option
                    v-for="item in freight"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="operationType !== 7 && operationType !== 8">
                <el-button class="btn-white" type="primary" @click="reset"
                  >取消</el-button
                >
                <el-button class="btn-blue" @click="submit">确定</el-button>
              </el-form-item>
            </el-form>
            <template v-if="operationType === 7">
              <div class="search-parameter">
                <el-input
                  class="gray"
                  placeholder="请输入参数名"
                  clearable
                  @keyup.enter.native="searchParameter"
                  v-model="parameterName"
                ></el-input>
                <el-button class="btn-blue" @click="searchParameter"
                  >筛选</el-button
                >
              </div>
              <div class="table table-parameter">
                <el-table
                  :data="parameterTable"
                  style="width: 100%"
                  max-height="400"
                >
                  <el-table-column
                    prop="parameterName"
                    label="参数名"
                    width="120"
                  ></el-table-column>
                  <el-table-column label="参数值">
                    <template slot-scope="scope">
                      <el-checkbox-group
                        v-model="operationForm.parameterCheckedData"
                      >
                        <el-checkbox
                          v-for="(value, index) in scope.row.parameterValue"
                          :label="value.id"
                          :key="index"
                          >{{ value.value }}</el-checkbox
                        >
                      </el-checkbox-group>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="page">
                  <pagination-tpl
                    :pageSize="parameterPageSize"
                    :total="parameterTotal"
                    :currentPage="parameterPage"
                    @queryChange="updateParameterPage"
                  ></pagination-tpl>
                </div>
              </div>
              <div class="dialog-footer-btn">
                <el-button class="btn-white" @click="reset">取消</el-button>
                <el-button class="btn-blue" @click="saveParameter"
                  >保存</el-button
                >
              </div>
            </template>
            <template v-if="operationType === 8">
              <div class="search-goodsSubordination">
                <el-input
                  class="gray"
                  placeholder="请输入供应商名称"
                  clearable
                  v-model="goodsSubordinationName"
                ></el-input>
                <el-button class="btn-blue" @click="searchGoodsSubordination"
                  >搜索</el-button
                >
              </div>
              <div class="table goodsSubordinationList-table">
                <el-table
                  :data="goodsSubordinationList"
                  style="width: 100%"
                  max-height="220"
                  v-loading="goodsSubordinationListLoading"
                  @row-click="rowClick"
                >
                  <el-table-column label="选择" width="50">
                    <template slot-scope="scope">
                      <el-radio :label="scope.row.supplierId" v-model="radioId"
                        >&nbsp;</el-radio
                      >
                    </template>
                  </el-table-column>
                  <el-table-column prop="username" label="名称"></el-table-column>
                </el-table>
              </div>
              <div slot="footer" class="dialog-footer">
                <el-button class="btn-white" @click="reset">取消</el-button>
                <el-button
                  class="btn-blue"
                  @click="confirmGoodsSubordinationList"
                  >确认</el-button
                >
              </div>
            </template>
          </el-dialog>
          <!-- 操作日志 -->
          <el-dialog class="dialogOperationLog" title="操作日志" :visible.sync="dialogOperationLogVisible" width="600px" top="20vh">
            <!-- 表格部分 -->
            <div class="table">
              <el-table
                height="260"
                v-loading="dialogOperationLogLoading"
                :data="dialogOperationLogTableData"
                ref="dialogOperationLogTableData"
              >
                <el-table-column label="操作时间"  prop="createTime" width="150"></el-table-column>
                <el-table-column label="操作人" prop="operator" width="90"></el-table-column>
                <el-table-column prop="target" label="对象">
                  <template slot-scope="scope">
                    <p class="operator-target" :title="scope.row.target">{{ scope.row.target }}</p>
                  </template>
                </el-table-column>
                <el-table-column prop="operatorContent" label="操作内容" width="160">
                  <template slot-scope="scope">
                    <p class="operator-content" :title="scope.row.operatorContent">{{ scope.row.operatorContent }}</p>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="table_pagination_operator">
              <pagination-tpl
                @queryChange="operatorUpdatePage"
                :pageSize="operatorPageSize"
                :currentPage="operatorPage"
                :total="operatorTotal"
              ></pagination-tpl>
            </div>
            <div slot="footer" class="dialogOperationLog-footer">
              <el-button class="btn-blue" type="primary" @click="dialogOperationLogVisible = false">确 定</el-button>
            </div>
          </el-dialog>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import {
  getDBOperationPermission,
  getXBBasicInformation,
} from "common/js/storage"; // 权限数据接口
import {
  formaTimeToSecond
} from "common/js/util.js";
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import PaginationTpl from "base/PaginationTpl";
import DBCommodity from "models/db/commodity.js";
import DBExcel from "models/db/excel.js";
const dbCommodity = new DBCommodity();
const dbExcel = new DBExcel();
let statusVal = ["下架", "上架", "未审核", "审核通过", "审核拒绝"];
export default {
  data() {
    return {
      operationList: [], // 权限列表数据
      // 页面按钮--商品上架/下架/编辑 商品导出 新增商品 商品删除 商品从属 审核
      operationsBtns: {
        roleGoodsManage: "ROLE_GOODS_manage",
        roleGoodsExport: "ROLE_GOODS_export",
        roleGoodsAdd: "ROLE_GOODS_add",
        roleGoodsDelete: "ROLE_GOODS_delete",
        roleGoodsSubordination: "ROLE_GOODS_subordinate",
        roleGoodsReview: "ROLE_GOODS_review",
      },
      form: {
        codeName: "",
        classify: [],
        state: "",
        brand: "", // 品牌
        time: [],
        sellOut: false,
        username: "",
      },
      formData: {
        codeName: "",
        classify: [],
        state: "",
        brand: "", // 品牌
        time: [],
        sellOut: false,
        username: "",
      },
      classify: [],
      brand: [], // 品牌数据存储
      label: [], // 商品标签存储
      freight: [], // 运费模板存储
      userNameList: [], // 商品从属
      defaultParams: {
        label: "cateName",
        value: "id",
        children: "children",
        checkStrictly: true,
      },
      state: [
        {
          value: 1,
          label: "上架",
        },
        {
          value: 0,
          label: "下架",
        },
        {
          value: 2,
          label: "待审核",
        },
      ],
      tableData: [
        // {
        //   id: 1,
        //   name: '华硕（ASUS)飞华硕（ASUS)飞行堡垒6',
        //   img: '图片',
        //   zip: 200333,
        //   state: '上架',
        //   categoryName: '手机',
        //   stock: 12,
        //   sales: 203,
        //   price: 123.12,
        //   cost: 100,
        //   time: '2019-3-4'
        // }
      ],
      total: 0, // 数据总数量
      page: 1,
      pageSize: 20,
      screenWidth: document.body.clientWidth,
      loading: true,
      goodsSubordinationListLoading: true,
      selectTableData: [], // 选中的商品数据
      operationType: "", // 批量操作状态
      dialogVisible: false,
      operationForm: {
        brand: "", // 品牌
        classify: "", // 分类
        label: "", // 标签
        status: 1, // 状态
        freightId: "", // 运费
        parameterCheckedData: [], // 选取的参数
      },
      parameterName: "", //参数名
      searchParameterName: "", //参数搜索值
      parameterTable: [], // 参数数据
      parameterPageSize: 0,
      parameterTotal: 0,
      parameterPage: 1,
      maidFlag: 1, //判断选品池开闭 1开 0闭
      goodsSubordinationList: [],
      radioId: "",
      goodsId: "",
      isModifySingleGoodsSubordinationList: false, // 是否修改单个商品从属
      goodsSubordinationName: '', // 搜索商品从属
      dialogOperationLogVisible: false,         // 操作日志开关
      dialogOperationLogTableData: [],
      dialogOperationLogLoading: true,
      operatorTotal: 0, // 数据总数量
      operatorPage: 1,
      operatorPageSize: 20,
      operatorGoodsId: ''
    };
  },
  components: {
    SecondMenuLinkContent,
    PaginationTpl,
  },
  watch: {
    // 监听窗口的变化
    screenWidth(val) {
      this.$refs["table_list"].style.width =
        this.$refs["table"].offsetWidth + "px";
    },
  },
  activated() {
    if (this.$route.params.change) {
      this.postGoods();
    }
  },
  created() {
    if (this.$route.query.sellOut) {
      this.form.sellOut = true;
      this.formData.sellOut = true;
    }
    this.operationList = getDBOperationPermission();
    this.maidFlag = getXBBasicInformation().moduleSelection;
    this.getGoodsClassify();
    this.getBrand();
    this.getLabel();
    this.postGoods();
    this.getFreight();
    this.getParameterData();
    this.getTableData();
    this.initGoodsSubordinationList()
  },
  mounted() {
    // 获取table的width
    // this.$refs["table_list"].style.width =
    //   this.$refs["table"].offsetWidth + "px";
    // const that = this;
    // window.onresize = () => {
    //   return (() => {
    //     window.screenWidth = document.body.clientWidth;
    //     that.screenWidth = window.screenWidth;
    //   })();
    // };
  },
  methods: {
    // 获取商品从属（搜索）
    getTableData() {
      dbCommodity.getDBSupplierList().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.username = value.username;
            arr.push(obj);
          });
          this.userNameList = arr;
        }
      });
    },
    // 跳转新增商品页面
    addcommodity() {
      this.$router.push("add-commodity");
    },
    // 获取商品分类列表
    getGoodsClassify() {
      dbCommodity.getDBGoodsClassify().then((res) => {
        if (res.success) {
          this.classify = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取品牌数据
    getBrand() {
      dbCommodity.getCommodityAllBrand().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value, index, Array) => {
            let obj = {};
            obj.name = value.name;
            obj.id = value.id;
            arr.push(obj);
          });
          this.brand = arr;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取标签数据
    getLabel() {
      dbCommodity.getDBLabel().then((res) => {
        if (res.success) {
          this.label = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取运费模板数据
    getFreight() {
      dbCommodity.getFreightAllList().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value, index, array) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.freight = arr;
        }
      });
    },
    // 获取商品列表
    postGoods() {
      this.selectTableData = [];
      let goodsName = this.formData.codeName ? this.formData.codeName : "";
      let currentPage = this.page;
      let category1Id =
        this.formData.classify.length > 0
          ? this.formData.classify[this.formData.classify.length - 1]
          : "";
      let minDate =
        this.formData.time && this.formData.time.length > 0
          ? this.formData.time[0]
          : "";
      let maxDate =
        this.formData.time && this.formData.time.length > 0
          ? this.formData.time[1]
          : "";
      let status = this.formData.state;
      let dbId = this.formData.username;
      let brandId = this.formData.brand ? this.formData.brand : "";
      let sellOut = this.formData.sellOut ? 1 : "";
      let options = {
        goodsName,
        currentPage,
        category1Id,
        minDate,
        maxDate,
        status,
        brandId,
        dbId,
        sellOut
      }
      dbCommodity
        .getDBGoods(options)
        .then((res) => {
          if (res.success) {
            this.total = res.result.totalNum;
            this.pageSize = res.result.pageSize;
            let arr = [];
            res.result.items.map((value, index, array) => {
              let obj = {};
              obj.id = value.id;
              obj.name = value.goodsName;
              obj.img = value.itemImages[0]
                ? value.itemImages[0]
                : "http://ydbtest.cnpu.com/img/bigImg.42a4bd12.png";
              obj.zip = value.code; // 商品编码
              obj.categoryName = value.categoryName;
              obj.state = statusVal[value.status];
              obj.status = value.status;
              obj.supplierStatus = value.supplierStatus;
              obj.username = value.username;
              obj.commissionRate = value.commissionRate * 100;
              obj.sales = value.saleTotal; // 销量
              obj.time = this.toDate(value.createTime);
              arr.push(obj);
            });
            this.tableData = arr;
            this.loading = false;
          } else {
            this.loading = false;
            this.$message.error("获取列表失败");
          }
        });
    },
    //获取参数数据
    getParameterData() {
      let searchValue = this.searchParameterName;
      let currentPage = this.parameterPage;
      dbCommodity.getParamsList(searchValue, currentPage).then((res) => {
        if (res.success) {
          this.parameterPageSize = res.result.pageSize;
          this.parameterTotal = res.result.totalNum;
          let arr = [];
          res.result.items.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.parameterName = value.name;
            obj.parameterValue = value.values;
            arr.push(obj);
          });
          this.parameterTable = arr;
        }
      });
    },
    toPreviewProduct(id) {
      window.open(`/admin/preview-product?id=${id}`, "_blank");
    },
    //参数翻页
    updateParameterPage(data) {
      this.parameterPage = data.currentPage;
      this.getParameterData();
    },
    //搜索参数
    searchParameter() {
      this.searchParameterName = this.parameterName;
      this.parameterPage = 1;
      this.getParameterData();
    },
    // 筛选商品
    screen() {
      this.formData = this.form;
      this.page = 1;
      this.postGoods();
    },
    // 导出报表
    exportExcel() {
      let goodsName = this.formData.codeName;
      let category1Id =
        this.formData.classify.length > 0
          ? this.formData.classify[this.formData.classify.length - 1]
          : "";
      let minDate =
        this.formData.time && this.formData.time.length > 0
          ? this.formData.time[0]
          : "";
      let maxDate =
        this.formData.time && this.formData.time.length > 0
          ? this.formData.time[1]
          : "";
      let status = this.formData.state;
      let brandId = this.formData.brand ? this.formData.brand : "";
      let options = {
        goodsName,
        category1Id,
        minDate,
        maxDate,
        status,
        brandId,
      };
      dbExcel.getGoodsExcel(options).then((res) => {
        let blob = new Blob([res.data], { type: res.headers.contentType });
        let fileName = window.decodeURI(
          res.headers["content-disposition"].split("=")[1]
        );
        var url = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        // 释放之前创建的URL对象
        window.URL.revokeObjectURL(url);
      });
    },
    // 清空表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.screen();
    },
    // 所选中的商品数据
    handleSelectionChange(val) {
      this.selectTableData = val;
    },
    changeOpenOperation() {
      this.openOperation = !this.openOperation;
    },
    // onCopy
    onCopy(e) {
      this.$message.success("复制商品链接成功");
    },
    // 编辑商品
    editRow(id) {
      this.$router.push({ path: "add-commodity", query: { id: id } });
    },
    // 上架商品
    upGoods(id) {
      this.$confirm(`是否确认上架该商品`, "上架商品", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        dbCommodity.getDBUpGoods(id).then((res) => {
          if (res.success) {
            this.postGoods();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    // 下架商品
    downGoods(id) {
      this.$confirm(`是否确认下架该商品`, "下架商品", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        dbCommodity.getDBDownGoods(id).then((res) => {
          if (res.success) {
            this.postGoods();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    //商品审核
    agreeGoods(id) {
      this.$confirm(`是否审核通过该商品`, "审核商品", {
        distinguishCancelAndClose: true,
        confirmButtonText: "通过",
        cancelButtonText: "拒绝",
        type: "warning",
      })
        .then(() => {
          dbCommodity.getDBAgreeGoods(id).then((res) => {
            if (res.success) {
              this.postGoods();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch((action) => {
          if (action === "cancel") {
            dbCommodity.getDBRejectGoods(id).then((res) => {
              if (res.success) {
                this.postGoods();
              } else {
                this.$message.error(res.message);
              }
            });
          }
        });
    },
    // 删除商品
    deleteRow(id) {
      this.$confirm(`是否确认删除该商品`, "删除商品", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let data = [id];
        dbCommodity.postCommodityBeforeDelete(data).then((res) => {
          console.log(res);
          if (res.success) {
            let promotion = res.result.promotion;
            if (promotion) {
              this.$confirm(
                `所选中的商品存在相关促销，确认操作将会同步删除，是否继续`,
                "删除商品",
                {
                  confirmButtonText: "确认",
                  cancelButtonText: "取消",
                  type: "warning",
                }
              ).then(() => {
                dbCommodity.getDBDeleteGoods(id).then((res) => {
                  if (res.success) {
                    this.postGoods();
                  } else {
                    this.$message.error(res.message);
                  }
                });
              });
            } else {
              dbCommodity.getDBDeleteGoods(id).then((res) => {
                if (res.success) {
                  this.postGoods();
                } else {
                  this.$message.error(res.message);
                }
              });
            }
          }
        });
      });
    },
    // 跳转页码
    updatePage(data) {
      this.page = data.currentPage;
      this.postGoods();
    },
    // 日期转换
    toDate(val) {
      let date = new Date(val);
      var year = date.getFullYear(); // 取得四位数的年份
      var month = date.getMonth() + 1; // 返回0~11之间的数字，0代表一月，11代表12月
      var day = date.getDate();
      return year + "-" + month + "-" + day;
    },
    evil(fn) {
      let Fn = Function; // 一个变量指向Function，防止有些前端编译工具报错
      return new Fn("return " + fn)();
    },
    // 批量操作显示弹窗
    openDialog(type) {
      if (this.selectTableData.length > 0) {
        this.operationType = type;
        this.dialogVisible = true;
        this.isModifySingleGoodsSubordinationList = false
        this.operationForm.brand = "";
        this.operationForm.classify = "";
        this.operationForm.label = "";
        this.operationForm.parameterCheckedData = [];
        this.operationForm.status = 1;
        this.operationForm.freightId = "";
        this.radioId = '';
        this.goodsSubordinationName = '';
        this.initGoodsSubordinationList()
      } else {
        this.$message.error("请选择商品");
      }
    },
    //关闭批量弹窗
    reset() {
      this.dialogVisible = false;
    },
    submit() {
      let ids = [];
      let type = this.operationType;
      this.selectTableData.map((value) => {
        ids.push(value.id);
      });
      if (type === 1) {
        let data = ids;
        dbCommodity.postCommodityBeforeDelete(data).then((res) => {
          console.log(res);
          if (res.success) {
            this.dialogVisible = false;
            let promotion = res.result.promotion;
            if (promotion) {
              this.$confirm(
                `所选中的商品存在相关促销，确认操作将会同步删除，是否继续`,
                "删除商品",
                {
                  confirmButtonText: "确认",
                  cancelButtonText: "取消",
                  type: "warning",
                }
              ).then(() => {
                let data = {
                  ids,
                  type,
                };
                dbCommodity.postCommodityOperation(data).then((res) => {
                  if (res.success) {
                    this.dialogVisible = false;
                    this.$message.success("删除成功");
                    this.postGoods();
                  } else {
                    this.$mrssage.error(res.message);
                  }
                });
              });
            } else {
              let data = {
                ids,
                type,
              };
              dbCommodity.postCommodityOperation(data).then((res) => {
                if (res.success) {
                  this.dialogVisible = false;
                  this.$message.success("删除成功");
                  this.postGoods();
                } else {
                  this.$mrssage.error(res.message);
                }
              });
            }
          }
        });
      } else if (type === 2) {
        let brandId = this.operationForm.brand;
        let data = {
          ids,
          type,
          brandId,
        };
        dbCommodity.postCommodityOperation(data).then((res) => {
          if (res.success) {
            this.dialogVisible = false;
            this.$message.success("品牌修改成功");
            this.postGoods();
          } else {
            this.$mrssage.error(res.message);
          }
        });
      } else if (type === 3) {
        let label = this.operationForm.label;
        let data = {
          ids,
          type,
          label,
        };
        dbCommodity.postCommodityOperation(data).then((res) => {
          if (res.success) {
            this.dialogVisible = false;
            this.$message.success("标签修改成功");
            this.postGoods();
          } else {
            this.$mrssage.error(res.message);
          }
        });
      } else if (type === 4) {
        let category1Id = this.operationForm.classify[0];
        let category2Id =
          this.operationForm.classify.length > 1
            ? this.operationForm.classify[1]
            : null;
        let category3Id =
          this.operationForm.classify.length > 2
            ? this.operationForm.classify[2]
            : null;
        let data = {
          ids,
          type,
          category1Id,
          category2Id,
          category3Id,
        };
        dbCommodity.postCommodityOperation(data).then((res) => {
          if (res.success) {
            this.dialogVisible = false;
            this.$message.success("分类修改成功");
            this.postGoods();
          } else {
            this.$mrssage.error(res.message);
          }
        });
      } else if (type === 5) {
        let status = this.operationForm.status;
        let data = {
          ids,
          type,
          status,
        };
        dbCommodity.postCommodityOperation(data).then((res) => {
          if (res.success) {
            this.dialogVisible = false;
            this.$message.success("状态修改成功");
            this.postGoods();
          } else {
            this.$mrssage.error(res.message);
          }
        });
      } else if (type === 6) {
        let trafficId = this.operationForm.freightId;
        let isDefaultTraffic = false;
        let data = {
          ids,
          type,
          trafficId,
          isDefaultTraffic,
        };
        dbCommodity.postCommodityOperation(data).then((res) => {
          if (res.success) {
            this.dialogVisible = false;
            this.$message.success("运费模板修改成功");
            this.postGoods();
          } else {
            this.$mrssage.error(res.message);
          }
        });
      }
    },
    saveParameter() {
      let ids = [];
      let type = this.operationType;
      this.selectTableData.map((value) => {
        ids.push(value.id);
      });
      let paramValueIds = this.operationForm.parameterCheckedData;
      let data = {
        ids,
        type,
        paramValueIds,
      };
      if (paramValueIds.length > 0) {
        dbCommodity.postCommodityOperation(data).then((res) => {
          if (res.success) {
            this.dialogVisible = false;
            this.$message.success("参数修改成功");
            this.postGoods();
          } else {
            this.$mrssage.error(res.message);
          }
        });
      } else {
        this.$message.error("请选择参数");
      }
    },
    rowClick(row) {
      this.radioId = row.id;
    },
    goodsSubordination(row) {
      this.operationType = 8;
      this.goodsId = row.id;
      this.isModifySingleGoodsSubordinationList = true
      this.dialogVisible = true;
      this.operationForm.brand = "";
      this.operationForm.classify = "";
      this.operationForm.label = "";
      this.operationForm.parameterCheckedData = [];
      this.operationForm.status = 1;
      this.operationForm.freightId = "";
      this.radioId = '';
      this.goodsSubordinationName = '';
      this.initGoodsSubordinationList()
    },
    /* 商品从属列表 */
    initGoodsSubordinationList() {
      let searchValue = this.goodsSubordinationName
      dbCommodity.getGoodsSubordinationList(searchValue).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(v => {
            let obj = {}
            obj.supplierId = v.id
            obj.username = v.username
            arr.push(obj)
          })
          this.goodsSubordinationList = arr
          this.goodsSubordinationListLoading = false
        } else {
          this.goodsSubordinationListLoading = false
          this.$mrssage.error(res.message);
        }
      })
    },
    /* 设置商品从属 */
    confirmGoodsSubordinationList() {
      let supplierId = this.radioId
      if (this.isModifySingleGoodsSubordinationList) {
        let goodsId = this.goodsId
        let data = {
          supplierId,
          goodsId
        }
        dbCommodity.postModifyGoodsSubordinationList(data).then(res => {
          if (res.success) {
            this.dialogVisible = false;
            this.$message.success("商品从属设置成功");
            this.postGoods();
          } else {
            this.$mrssage.error(res.message);
          }
        });
      } else {
        let ids = [];
        let type = this.operationType;
        this.selectTableData.map((value) => {
          ids.push(value.id);
        });
        let data = {
          type,
          ids,
          supplierId
        };
        dbCommodity.postCommodityOperation(data).then((res) => {
          if (res.success) {
            this.dialogVisible = false;
            this.$message.success("商品从属设置成功");
            this.postGoods();
          } else {
            this.$mrssage.error(res.message);
          }
        });
      }
    },
    /* 搜索商品从属(弹框) */
    searchGoodsSubordination() {
      this.initGoodsSubordinationList()
    },
    /* 打开操作日志 */
    operationLog(id) {
      this.operatorGoodsId = id
      this.initOperationLog()
      this.dialogOperationLogVisible = true
    },
    operatorUpdatePage(data) {
      this.operatorPage = data.currentPage;
      this.initOperationLog();
    },
    initOperationLog() {
      let goodsId = this.operatorGoodsId
      let pageNo = this.operatorPage
      dbCommodity.getOperatorLog(goodsId, pageNo).then((res) => {
        if (res.success) {
          let arr = []
          this.operatorPageSize = res.result.pageSize;
          this.operatorTotal = res.result.totalNum;
          res.result.items.map(i => {
            let obj = {}
            obj.createTime = formaTimeToSecond(i.operateTime)
            obj.operator = i.operateName
            if (i.skuFlag) {
              let normList = JSON.parse(i.operateObj);
              let normDesc = "";
              for (let key in normList) {
                normDesc += `,${normList[key]}`;
              }
              obj.target = normDesc.substring(1)
            } else {
              obj.target = i.operateObj
            }
            obj.operatorContent = i.operateContent
            arr.push(obj)
          })
          this.dialogOperationLogTableData = arr;
          this.dialogOperationLogLoading = false
        } else {
          this.dialogOperationLogLoading = false
          this.$message.error(res.message);
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.commodity-list {
  width: 100%;
  height: 100%;
  .commodity-list-main {
    width: 100%;
    .btn {
      padding: 0 0 16px 0;
      .btn-blue {
        letter-spacing: 2px;
        width: 128px;
      }
    }
    .form {
      box-sizing: border-box;
      height: 160px;
      background: rgba(245, 247, 250, 1);
      border-radius: 4px;
      padding-top: 16px;
      .el-input {
        width: 280px;
      }
      .flex {
        display: flex;
        .inventory-text {
          color: #999;
          font-size: 12px;
        }
      }
      .btn-white {
        width: 128px;
        letter-spacing: 2px;
      }
      .el-button + .el-button {
        margin-left: 16px;
      }
    }
    .operationLog {
      color: #3d74f2;
      cursor: pointer;
      margin-top: 8px;
    }
    .table {
      box-sizing: border-box;
      padding: 16px 0 56px 0;
      display: flex;
      flex-direction: column;
      position: relative;
      .table_pagination {
        height: 56px;
        position: absolute;
        bottom: 0;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .batch-operation {
          position: relative;
          .btn-white {
            width: 120px;
          }
          .operation-list {
            display: none;
            padding: 10px 0;
            z-index: 1000;
            position: absolute;
            left: 0;
            bottom: 32px;
            background: #fff;
            border-radius: 4px 4px 0px 0px;
            box-shadow: 0px 7px 10px 0px rgba(35, 52, 70, 0.14);
            li {
              font-size: 14px;
              width: 120px;
              height: 32px;
              line-height: 32px;
              text-align: center;
              cursor: pointer;
              color: #666666;
            }
            li:hover {
              color: #3d74f2;
            }
          }
        }
        .batch-operation:hover {
          .operation-list {
            display: inline-block;
          }
        }
        .el-pagination {
          height: 28px;
          padding: 0px;
          display: flex;
        }
      }
    }
    .goodsSubordinationList-table {
      padding-top: 0px;
    }
    .active {
      color: #3d74f2;
      cursor: pointer;
    }
    .operator-content {
      width: 136px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .operator-target {
      width: 142px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
<style lang="scss">
.commodity-list {
  .commodity-list-main {
    .form {
      .el-form-item {
        height: 32px;
      }
      .el-form-item__label {
        padding: 0;
      }
      .w160 {
        width: 160px;
        height: 32px;
        line-height: 32px;
        .el-input__suffix {
          height: 40px;
          top: -3px;
          right: 0px;
        }
        .el-input__inner {
          height: 32px;
          background: #fff;
        }
      }
      .w96 {
        width: 96px;
      }
      .w280 {
        width: 280px;
        // .el-form-item__content {
        //   /* width: 280px; */
        //   display: flex;
        //   .el-select {
        //     width: 96px;
        //     margin-right: 24px;
        //   }
        //   > .el-input {
        //     width: 160px;
        //   }
        // }
      }
    }
    .table {
      .el-table__header-wrapper {
        background: rgba(245, 247, 250, 1);
        .el-table__header {
          background: rgba(245, 247, 250, 1);
          .has-gutter {
            th {
              height: 32px;
            }
          }
        }
      }
      .el-table {
        border: 1px solid #f2f6fc;
        border-top: 0;
        border-radius: 8px 8px 0px 0px;
        color: #606266;
        font-size: 14px;
        letter-spacing: 1px;
        th {
          padding: 5px 0;
          height: 32px;
          color: rgba(96, 98, 102, 1);
          line-height: 22px;
          font-size: 14px;
          font-weight: normal;
          background: rgba(245, 247, 250, 1);
        }
        .el-table__row {
          .cell {
            display: flex;
            align-items: center;
            .img {
              width: 40px;
              height: 40px;
              margin-right: 8px;
              line-height: 40px;
              text-align: center;
            }
            .name {
              width: 200px;
              font-size: 12px;
              line-height: 20px;
              white-space: pre-wrap;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              letter-spacing: 0px;
              color: rgba(96, 98, 102, 1);
            }
            .img:hover {
              cursor: pointer;
            }
            .green {
              display: inline-block;
              width: 5px;
              height: 5px;
              border-radius: 50%;
              background: #2ad346;
              margin-right: 5px;
            }
            .orange {
              display: inline-block;
              width: 5px;
              height: 5px;
              border-radius: 50%;
              margin-right: 5px;
              background: #f49064;
            }
          }
        }
        .el-table__body-wrapper {
          .hover-row {
            td {
              background: rgba(245, 247, 250, 1);
            }
          }
          td {
            padding: 0;
            .cell {
              height: 56px;
              font-size: 12px;
              line-height: 14px;
              padding-right: 0;
              padding-left: 10px;
              .up-down-update {
                margin-right: 10px;
              }
            }
          }
        }
        .el-table__header-wrapper .el-table__header tr th .cell {
          padding: 8px 10px;
        }
        /* .el-table__fixed-right {
          box-shadow: -3px 0px 8px 0px rgba(0, 0, 0, 0.11);
          th {
            .cell {
              text-align: center;
            }
          }
          td {
            padding: 0;
            .cell {
              height: 56px;
              line-height: 56px;
              padding: 0 16px;
              display: flex;
              justify-content: space-between;
              .up-down-update {
                flex: 2;
                display: flex;
                justify-content: space-around;
                .update {
                  margin-right: 5px;
                }
              }
              > .el-button {
                flex: 1;
              }
            }
            background: rgba(245, 247, 250, 1);
            .el-button--text {
              color: #3d74f2;
              font-size: 12px;
            }
          }
        }
        .el-table__fixed-right-patch {
          background: rgba(245, 247, 250, 1);
        } */
      }
    }
    .goodsSubordinationList-table {
      .el-table {
        border-radius: 0px;
        &::before {
          height: 0;
        }
      }
    }
    .goodsSubordinationList {
      .el-dialog__header {
        border-bottom: 1px solid #eee;
        margin-bottom: 16px;
      }
      .el-dialog__footer {
        border-top: 1px solid #eee;
        padding: 15px 20px;
      }
      .dialog-footer {
        display: flex;
        justify-content: center;
      }
    }
    .el-dialog {
      .search-parameter {
        display: flex;
        .el-input {
          width: 240px;
          margin-right: 16px;
        }
      }
      .search-goodsSubordination {
        display: flex;
        .el-input {
          margin-right: 16px;
          margin-bottom: 16px;
        }
      }
      .text {
        font-size: 12px;
        padding-bottom: 10px;
        display: flex;
        justify-content: space-between;
        .el-button {
          height: 24px;
          font-size: 12px;
        }
      }
      .table {
        padding-bottom: 0;
        border-bottom: 1px solid #f7f7f7;
        .el-checkbox {
          width: 90px;
          line-height: 24px;
          .el-checkbox__label {
            font-size: 12px;
          }
        }
        .page {
          display: flex;
          justify-content: flex-end;
        }
        .el-table .el-table__header-wrapper .el-table__header tr th .cell {
          font-size: 12px;
        }
        .el-table .el-table__body-wrapper .el-table__body tr td .cell {
          height: auto;
        }
      }
      .dialog-footer-btn {
        display: flex;
        justify-content: center;
        padding-top: 16px;
      }
    }
    .dialogOperationLog {
      .table {
        height: 260px;
        padding-bottom: 0px;
      }
      .el-dialog__header {
        padding: 0;
        padding-left: 20px;
        border-bottom: 1px solid #eee;
      }
      .el-dialog__footer {
        padding: 20px 0px;
        border-top: 1px solid #eee;
        .dialogOperationLog-footer {
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .table_pagination_operator {
        width: 100%;
        height: 56px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }
  }
}
</style>
